import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Home, 
  TrendingUp, 
  Trophy, 
  User, 
  Users, 
  LogOut,
  DollarSign
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Dashboard' },
    { path: '/trade', icon: TrendingUp, label: 'Create Bet', highlight: true },
    { path: '/leaderboard', icon: Trophy, label: 'Leaderboard' },
    { path: '/rooms', icon: Users, label: 'Rooms' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  return (
    <nav className="bg-black bg-opacity-50 backdrop-blur-lg border-b border-gray-700">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/dashboard" className="flex items-center space-x-2">
            <span className="text-2xl">🎰</span>
            <span className="text-xl font-bold text-white neon-text">TradeBet</span>
          </Link>

          {/* Navigation Items */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${
                  location.pathname === item.path ? 'active' : ''
                } ${item.highlight ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold' : ''}`}
              >
                <item.icon className="w-4 h-4 mr-2" />
                {item.label}
                {item.highlight && <span className="ml-1">🎯</span>}
              </Link>
            ))}
          </div>

          {/* User Info & Logout */}
          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-2 text-white">
                <DollarSign className="w-4 h-4 text-green-400" />
                <span className="font-bold text-green-400">
                  ${user.balance?.toLocaleString() || '5,000'}
                </span>
                <span className="text-gray-400">|</span>
                <span className="text-sm">{user.username || 'Player'}</span>
              </div>
            )}
            
            <button
              onClick={handleLogout}
              className="flex items-center space-x-1 px-3 py-2 text-gray-300 hover:text-white hover:bg-red-600 rounded-lg transition-all duration-200"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:block">Logout</span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden pb-4">
          <div className="flex justify-between">
            {navItems.slice(0, 4).map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center space-y-1 px-2 py-2 rounded-lg ${
                  location.pathname === item.path 
                    ? 'text-white bg-white bg-opacity-20' 
                    : 'text-gray-400'
                }`}
              >
                <item.icon className="w-5 h-5" />
                <span className="text-xs">{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;